import { ApiResponseType } from '@/types';
import { AxiosResponse } from 'axios';

type UnreadCountPayload = number | { data: number };

export const parseUnreadCount = (
  response: AxiosResponse<ApiResponseType<UnreadCountPayload>> | undefined
): number => {
  const payload = response?.data?.data;

  if (typeof payload === 'number') {
    return payload;
  }

  if (payload && typeof payload === 'object' && 'data' in payload) {
    return typeof payload.data === 'number' ? payload.data : 0;
  }

  return 0;
};
